module.exports = __webpack_public_path__ + "img/ably_tile.ed257cd4.png";